import "./style.css"
import ButtonBasic from '../buttonBasic/view';
import { useState } from 'react';

function ButtonToggle(props) {

    const [isOn, setIsOn] = useState(false)

    function handleClick() {
        setIsOn(!isOn)
        props.onClick ? props.onClick() : null
    }

    return (
        <ButtonBasic
            style={props.style?props.style:{}}
            id={props.id ? "modal-btn-basic-" + props.id : "modal-btn-basic"}
            disabled={props.disabled ? props.disabled : false}
            className={'btn-toggle'+(isOn ? '--on' : '')}
            hidden={props.hidden ? props.hidden : false}
            onClick={handleClick}
        >
            {props.children}
        </ButtonBasic>
    )
}

export default ButtonToggle
